import { functionsUrl } from "@/plugins/firebase";
import { ActionContext, ActionTree } from "vuex";

import { Mutations } from "./mutations";
import { State } from "./state";

const axios = require("axios").default;

type AugmentedActionContext = {
  commit<K extends keyof Mutations>(
    key: K,
    payload: Parameters<Mutations[K]>[1]
  ): ReturnType<Mutations[K]>;
} & Omit<ActionContext<State, State>, "commit">;

export interface Actions {
  submitScore(
    { commit }: AugmentedActionContext,
    value: { name: string; type: string; email: string; score: number }
  ): Promise<boolean>;

  incrementAnswer(
    { commit }: AugmentedActionContext,
    value: { key: string; questionId: string }
  ): Promise<boolean>;

  submitComment(
    { commit }: AugmentedActionContext,
    value: { name: string; organisation: string; comment: string; date: Date }
  ): Promise<boolean>;
}

export const actions: ActionTree<State, State> & Actions = {
  async submitScore(
    { commit },
    value: { name: string; type: string; email: string; score: number }
  ) {
    try {
      await axios.post(`${functionsUrl}submitScore`, {
        name: value.name,
        type: value.type,
        email: value.email,
        score: value.score,
      });

      return true;
    } catch (error) {
      console.log("error", error);
    }

    return false;
  },
  async submitComment(
    { commit },
    value: { name: string; organisation: string; comment: string; date: Date }
  ) {
    try {
      await axios.post(`${functionsUrl}submitComment`, {
        name: value.name,
        organisation: value.organisation,
        comment: value.comment,
        date: value.date,
      });

      return true;
    } catch (error) {
      console.log("error", error);
    }

    return false;
  },

  async incrementAnswer(
    { commit },
    value: { key: string; questionId: string }
  ) {
    try {
      await axios.post(`${functionsUrl}incrementAnswer`, {
        key: value.key,
        questionId: value.questionId,
      });

      return true;
    } catch (error) {
      console.log("error", error);
    }
    return false;
  },

  async addPlay({ commit }) {
    try {
      await axios.post(`${functionsUrl}addPlay`);

      return true;
    } catch (error) {
      console.log("error", error);
    }

    return false;
  },
};
